import { Component } from "@angular/core";
import { GoogleAnalyticsService } from "@/core/services";

@Component({ templateUrl: "pageerror.component.html" })
export class PageErrorComponent {
  constructor(private googleService: GoogleAnalyticsService) {
    this.googleService.record(
      "navigation",
      "error page",
      "navigate to error page",
    );
  }
}
